/* eslint-disable */
export default {
    mobileHelper() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },

    /**
     * return true, if screen is smaller than x
     * @param breakpoint
     * @returns {boolean}
     */
    smallScreenHelper(breakpoint) {
        return $(window).width() <= breakpoint;
    },

    /**
     *
     * @param target
     * @param topPosition
     * @returns {boolean}
     */
    smoothScroll(target, topPosition = 0) {
        $('html, body').animate({
            scrollTop: target.offset().top - topPosition
        }, 500);
        return false;
    }
}


// WEBPACK FOOTER //
// ./scripts/util/Helper.js